// extracted by mini-css-extract-plugin
export default {"base":"toggle_base__dQbg9","selected-indicator":"toggle_selected-indicator__0JwjM","option":"toggle_option__XuaJE","selected":"toggle_selected__aJS81"};